import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LojistikIrsaliyeKalemMiktarOnaylananlarPage } from 'src/model/lojistik-irsaliye-kalem-miktar-onaylananlar-page';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-kantar',
  templateUrl: './kantar.component.html',
  styleUrls: ['./kantar.component.css']
})
export class KantarComponent implements OnInit {

  showSearchResultCount = 10;
  showSearchResultCountModel: number[] = [10, 20, 50, 100];
  irsaliyeAraLoading = false;
  irsaliyeAraText = '';
  source: LojistikIrsaliyeKalemMiktarOnaylananlarPage = null;
  showSearchCurrentPage = 1;
  basTar: Date = null;
  bitTar: Date = null;
  // filterStatus: Pair[] = [];

  constructor(private restService: RestService) { }

  ngOnInit() {
    this.getIrsaliyeKalemler();
  }

  showPreviousPageSearchResults() {
    this.showSearchCurrentPage--;
    this.getIrsaliyeKalemler();
  }

  showNextPageSearchResults() {
    this.showSearchCurrentPage++;
    this.getIrsaliyeKalemler();
  }

  irsaliyeAraInputChange() {
    this.showSearchCurrentPage = 1;
    this.getIrsaliyeKalemler();
  }

  getIrsaliyeKalemler() {
    this.restService.getLojistikIrsaliyeKalemMiktarOnaylananlar(
        this.showSearchCurrentPage, this.showSearchResultCount
        // , this.dateToString(this.basTar), this.dateToString(this.bitTar)
        , this.dateToTicks(this.basTar), this.dateToTicks(this.bitTar)
        , this.irsaliyeAraText).subscribe(res => {
      this.source = res;
    });
  }

  tarihTemizle(x: any) {
    if (x === 1)
      this.basTar = null;
    else if (x === 2)
      this.bitTar = null;
  }

  getirButonDisabled(): boolean {
    if (this.basTar === null || this.bitTar === null)
      return true;

    return false;
  }

  dateToTicks(date: Date) : string{
    if (date !== null)
      return date.toLocaleDateString();

    return null;
  }
}
